var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 24,
    viewBox: "0 0 105 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_354_257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H7.05002C11.1728 0 14.5233 3.48747 14.5233 7.78525C14.5233 12.146 11.1261 15.685 6.94008 15.685H0V0Z",
    fill: "#FF7A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9246 0H72.9746C77.0975 0 80.4452 3.48747 80.4452 7.78525C80.4452 12.146 77.048 15.685 72.862 15.685H65.9219V0H65.9246Z",
    fill: "#FF7A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2912 15.6851H56.3511C52.1678 15.6851 48.7706 12.146 48.7706 7.78527C48.7706 3.48749 52.1184 1.81198e-05 56.2439 1.81198e-05L63.2939 1.81198e-05V15.6851H63.2912Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6519 0H88.9135V15.5705C88.9135 15.6335 88.864 15.685 88.8036 15.685H81.6519V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6934 15.4072V8.06292C31.6934 3.768 35.0411 0.277664 39.1667 0.277664C43.3527 0.277664 46.7499 3.81668 46.7499 8.17745V15.4072L31.6934 15.4072Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2739 7.03516C91.2739 3.30717 94.1791 0.277817 97.7605 0.277817H97.9666C101.512 0.277817 104.39 3.27567 104.39 6.9693V7.03516L91.2739 7.03516Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.39 8.6499C104.39 12.3779 101.485 15.4072 97.9036 15.4072H97.6974C94.1518 15.4072 91.2741 12.4094 91.2741 8.71576V8.6499H104.39Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2915 17.2427C63.2915 20.9707 60.3863 24 56.8049 24H56.5988C53.0532 24 50.1754 21.0022 50.1754 17.3085V17.2427H63.2915Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.799 0H22.9227C26.8944 0 30.1212 3.36149 30.1212 7.49893V8.0544C30.1212 12.2634 26.8394 15.6822 22.799 15.6822C18.8246 15.6822 15.6006 12.3207 15.6006 8.18325V7.49893C15.5978 3.36149 18.8246 0 22.799 0Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_354_257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2a2815d35a018f2db1a9e9a7e8e6bc26.svg";
export { ForwardRef as ReactComponent };